export default "__VITE_ASSET__365acd4c__"